import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
    font-size: 36px;
    opacity: 0.7;
  }
`;
